// extracted by mini-css-extract-plugin
export default {"heading":"timediv_heading__y9YGE","info":"timediv_info__3rWBm","box":"timediv_box__bJmcU","info2":"timediv_info2__NBKBq"};